import React, { useMemo } from 'react';
import { FiservCardInterface, FiservCardStatusEnum, Hint, Inscription } from '@common-fe/common-fe';
import dayjs from 'dayjs';

interface DisableActionHintWrapperProps {
  card?: FiservCardInterface;
  hideHint: boolean;
  hintElement: React.ReactNode;
}
const ONE_LINE_HEIGHT = 60;

const DisableActionHintWrapper = ({ card, hideHint, hintElement }: DisableActionHintWrapperProps) => {
  const numberOfDaysToReplace = useMemo(() => {
    if (!card?.mailedDate) return null;
    const mailed = dayjs(card.mailedDate).startOf('day');
    const eighthDay = mailed.add(7, 'day');
    const today = dayjs().startOf('day');
    const diff = eighthDay.diff(today, 'day');
    return diff > 0 ? diff : 0;
  }, [card?.mailedDate]);

  const labelText = useMemo(() => {
    if (
      card?.status === FiservCardStatusEnum.PENDING_UNLOCK ||
      card?.status === FiservCardStatusEnum.ACTIVE
    ) {
      const dayText = numberOfDaysToReplace === 1 ? 'day' : 'days';
      return `You will be able to request a new card in ${numberOfDaysToReplace || ''} ${dayText}`;
    }
    return 'Your card is on its way and should arrive soon';
  }, [card?.status, numberOfDaysToReplace]);

  return (
    <Hint
      hintAlign="bottom"
      hideHint={hideHint}
      hintElement={hintElement}
      contentStyles={{ width: 'fit-content' }}
      hintHeight={ONE_LINE_HEIGHT}
    >
      <Inscription size="12px" textAlign="center">
        {labelText}
      </Inscription>
    </Hint>
  );
};

export default DisableActionHintWrapper;
